import { EventService, EnumService, GlobalSettingService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";
import * as CONSTANTS from "./constants";

const setLoading = (val, message = "") => async (dispatch, getState) => {
  try {
    if (val === true) {
      dispatch({ type: CONSTANTS.SET_LOADING_TRUE, payload: message });
    } else {
      dispatch({ type: CONSTANTS.SET_LOADING_FALSE, payload: "" });
    }
  } catch (error) {
    handleConsoleError(error);
    return null;
  }
};

const toggleCodeVerification = (val, userId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: CONSTANTS.VERIFY_MODAL_TOGGLE,
      payload: { value: val, userId: userId },
    });
  } catch (error) {
    handleConsoleError(error, "toggleCodeVerification");
    return null;
  }
};

export const setActiveRole = (val) => async (dispatch, getState) => {
  try {
    if (val === true) {
      dispatch({ type: CONSTANTS.SET_ACTIVE_ROLE, payload: val });
    } else {
      dispatch({ type: CONSTANTS.SET_ACTIVE_ROLE, payload: "" });
    }
  } catch (error) {
    handleConsoleError(error, "setActiveRole");
    return null;
  }
};

export const getEventCategories = () => async (dispatch, getState) => {
  try {
    const response = await EventService.getEventActiveCategoryList();

    if (response?.isSuccess) {
      dispatch({
        type: CONSTANTS.GET_EVENT_CATEGORIES,
        payload: response?.data ?? [],
      });
      return response;
    } else {
      dispatch({ type: CONSTANTS.GET_EVENT_CATEGORIES, payload: [] });
      return response;
    }
  } catch (error) {
    dispatch({ type: CONSTANTS.GET_EVENT_CATEGORIES, payload: [] });
    return null;//Promise.reject(error);
  }
};

export const getEventsByCategoryId = (id) => async (dispatch, getState) => {
  try {
    const response = await EventService.getEventByCategoryId(id);

    if (response?.isSuccess) {
      dispatch({
        type: CONSTANTS.GET_EVENTS_BY_CATEGORY,
        payload: response?.data ?? [],
      });
      return response;
    } else {
      dispatch({ type: CONSTANTS.GET_EVENTS_BY_CATEGORY, payload: [] });
      return response;
    }
  } catch (error) {
    dispatch({ type: CONSTANTS.GET_EVENTS_BY_CATEGORY, payload: [] });
    return null;//Promise.reject(error);
  }
};

export const getRoles = () => async (dispatch, getState) => {
  try {
    const response = await EnumService.getRoleList();

    if (response?.isSuccess) {
      dispatch({
        type: CONSTANTS.GET_ALL_USER_ROLES,
        payload: response?.data ?? [],
      });
      return response;
    } else {
      dispatch({ type: CONSTANTS.GET_ALL_USER_ROLES, payload: [] });
      return response;
    }
  } catch (error) {
    dispatch({ type: CONSTANTS.GET_ALL_USER_ROLES, payload: [] });
    return null;//Promise.reject(error);
  }
};


export const getSwallowEO = () => async (dispatch, getState) => {
  try {
    const response = await GlobalSettingService.getSwallowEODetails();

    if (response?.isSuccess && response?.data) {
      const eoId=GlobalSettingService.decrypt(response?.data?.keyValue);
      dispatch({
        type: CONSTANTS.SET_SWALLOW_EO,
        payload: eoId,
      });
      return response;
    }
  } catch (error) {   
    return null;//Promise.reject(error);
  }
};

export { setLoading, toggleCodeVerification };
